
import { useDispatch } from 'react-redux';
import { setPnrTokenData } from '../actionCreators/initToken';

export function ResetPNRToken() {
    const dispatch = useDispatch();

    dispatch(setPnrTokenData(""));
}